import { Studio, StudioConfigType } from 'Core/Studio'
import { ITask, TaskAdapter } from 'Core/TaskAdapter'
import { Timer } from 'Core/Timer'
import { TaskPromptType } from 'Types/Tasks.types'
import { TaskActivityController } from 'Core/TaskActivityController'

export class TaskManager {
    private task?: ITask
    private readonly taskAdapter: TaskAdapter
    public readonly timer: Timer
    private readonly taskActivityController: TaskActivityController
    private promptContent: TaskPromptType

    constructor(studio: Studio) {
        this.taskAdapter = new TaskAdapter(studio)
        this.timer = new Timer()
        this.taskActivityController = new TaskActivityController(
            studio.taskConfig.assignment.task.config.activity_check_config,
            this.timer,
            this.getTask
        )
        this.promptContent = {
            value_type: 'STRING',
            value: '',
        }
    }

    public getTask = () => this.task

    public initializeTask(studioConfig: StudioConfigType) {
        this.task = this.taskAdapter.adapt(studioConfig)
        this.task?.initialize(studioConfig.taskConfig)
    }

    public setPromptContent(promptContent?: TaskPromptType) {
        if (promptContent) {
            this.promptContent = promptContent
        }
    }

    public getPromptContent() {
        return this.promptContent
    }

    public shouldEnableViolations() {
        return this.task?.shouldEnableViolations() ?? true
    }

    startTaskActivityMonitoring() {
        this.taskActivityController.start()
    }

    stopTaskActivityMonitoring() {
        this.taskActivityController.stop()
    }

    destroy() {
        this.task?.destroy()
        this.task = undefined
    }
}
